export default "__VITE_ASSET__Dm00jy10__"